import React from 'react';
import { Link } from 'react-router-dom';
import { ArtistData } from './artistData';
import './styles.css';

interface ArtistCardProps {
  artist: ArtistData;
  variant?: 'list' | 'modal';
}

const ArtistCard: React.FC<ArtistCardProps> = ({ artist, variant = 'list' }) => {
  const containerClass = variant === 'modal' ? 'modal-artist-item' : 'artist-item';
  const infoClass = variant === 'modal' ? 'modal-artist-info' : 'artist-info';
  const nameContainerClass = variant === 'modal' ? 'modal-artist-name-container' : 'artist-name-container';
  const nameClass = variant === 'modal' ? 'modal-artist-name' : 'artist-name';
  const verifiedBadgeClass = variant === 'modal' ? 'modal-verified-badge' : 'verified-badge';
  const statsClass = variant === 'modal' ? 'modal-artist-stats' : 'artist-stats';
  const listenersClass = variant === 'modal' ? 'modal-artist-listeners' : 'artist-listeners suisse';
  const tracksClass = variant === 'modal' ? 'modal-artist-tracks' : 'artist-tracks suisse';

  return (
    <Link to={`/artist/${artist.id}`}>
    <div className={containerClass}>
      <div className="artist-avatar">
        {artist.avatarUrl ? (
          <img 
            src={artist.avatarUrl} 
            alt={`${artist.name} avatar`}
            className="avatar-image"
          />
        ) : (
          <div className="avatar-placeholder">
            {artist.name.charAt(0).toUpperCase()}
          </div>
        )}
      </div>
      
      <div className={infoClass}>
        <div className={nameContainerClass}>
          <h3 className={nameClass}>{artist.name}</h3>
          {/* {artist.verified && (
            <span className={verifiedBadgeClass} title="Verified Artist">
              <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" aria-hidden="false">
                <title>Verified</title>
                <path d="M15 8A7 7 0 111 8a7 7 0 0114 0z" fill="currentColor"></path>
                <path d="M11.97 4.7l1.06 1.06-6.53 6.531-3.53-3.53L4.03 7.7l2.47 2.47 5.47-5.47z" fill="#fff"></path>
              </svg>
            </span>
          )} */}
        </div>
        {/* <div className={statsClass}>
          <div className="stat-item">
            <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" className="stat-icon">
              <g fill="currentColor">
                <path d="M8 7.5a3 3 0 100-6 3 3 0 000 6zM2.001 14.248C2.036 10.005 2.984 8.5 8 8.5s5.965 1.487 5.999 5.748a.25.25 0 01-.249.252H2.25a.25.25 0 01-.249-.252z"></path>
              </g>
            </svg>
            <span className={listenersClass}>
              {artist.listeners.toLocaleString()} followers
            </span>
          </div>
          <div className="stat-item">
            <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" className="stat-icon">
              <path d="M5.75 2v12h1.5V2h-1.5zM13.25 10V6h-1.5v4h1.5zM4.25 5v6h-1.5V5h1.5zM8.75 4v8h1.5V4h-1.5z" fill="currentColor"></path>
            </svg>
            <span className={tracksClass}>
              {artist.tracks} tracks
            </span>
          </div>
        </div> */}
      </div>
{/*       
      {variant === 'list' && (
        <Link 
          to={`/artist/${artist.id}`}
          className="artist-link"
        >
          View Profile
        </Link>
      )} */}
    </div>
    </Link>
  );
};

export default ArtistCard;
